module.exports = __webpack_public_path__ + "img/8.aa3b8388.png";